module.exports = __webpack_public_path__ + "static/media/logoLine.b78533cd.webp";